import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { AppDatePipe } from "../../common/pipes/app-date";
import { SecondsToDHMPipe } from "../../common/pipes/seconds-to-DHM-pipe";
import { DefaultPipe } from "../../common/pipes/default";
import { TableHistogramChartComponent } from "../../common/components/table-histogram-chart/table-histogram-chart";
import { NgIf } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { UtilsProvider } from "../../common/providers/utils-provider.service";

@Component({
  selector: 'app-mobile-diary-list-section',
  styleUrls: ['./mobile.diary-list-section.component.scss'],
  standalone: true,
  imports: [
    FlexLayoutModule,
    AppDatePipe,
    SecondsToDHMPipe,
    DefaultPipe,
    TableHistogramChartComponent,
    NgIf
  ],
  templateUrl: './mobile.diary-list-section.component.html'
})
export class MobileDiaryListSectionComponent {
    @Input() public content: any;

    public currentLocale: string;
    public timeOnly = '';

    constructor(
      private ts: TranslateService,
    ) {
      this.currentLocale = this.ts.currentLang;
    }

}
